import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Web3Modal from "web3modal"

import Countdown from 'react-countdown';
import a1 from "../im/ava.png"

import { useHistory } from "react-router-dom"


import {
  marketplaceAddress
  } from '../../config'
  

  import NFTMarketplace from '../../utils/ropston/NFTMarketplace.json'
export default function MyAssets() {
  // const [nfts, setNfts] = useState([])
  // const [loadingState, setLoadingState] = useState('not-loaded')
  // useEffect(() => {
  //   loadNFTs()
  // }, [])
  // async function loadNFTs() {
  //   const web3Modal = new Web3Modal({
  //     network: "mainnet",
  //     cacheProvider: true,
  //   })
  //   const connection = await web3Modal.connect()
  //   const provider = new ethers.providers.Web3Provider(connection)
  //   const signer = provider.getSigner()

  //   const marketContract = new ethers.Contract(nftmarketaddress, Market.abi, signer)
  //   const tokenContract = new ethers.Contract(nftaddress, NFT.abi, provider)
  //   const data = await marketContract.fetchMyNFTs()

  //   const items = await Promise.all(data.map(async i => {
  //     const tokenUri = await tokenContract.tokenURI(i.tokenId)
  //     const meta = await axios.get(tokenUri)
  //     let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
  //     let item = {
  //       price,
  //       tokenId: i.tokenId.toNumber(),
  //       seller: i.seller,
  //       owner: i.owner,
  //       image: meta.data.image,
  //     }
  //     return item
  //   }))
  //   setNfts(items)
  //   setLoadingState('loaded') 
  // }

  const [nfts, setNfts] = useState([])
  const [loadingState, setLoadingState] = useState('not-loaded')
  const history = useHistory()
  useEffect(() => {
    loadNFTs()
  }, [])
  async function loadNFTs() {
    const web3Modal = new Web3Modal({
      network: "mainnet",
      cacheProvider: true,
    })
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()

    const marketplaceContract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, signer)
    const data = await marketplaceContract.fetchMyNFTs()

    const items = await Promise.all(data.map(async i => {
      const tokenURI = await marketplaceContract.tokenURI(i.tokenId)
      const meta = await axios.get(tokenURI)
      let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
      let item = {
        price,
        tokenId: i.tokenId.toNumber(),
        seller: i.seller,
        owner: i.owner,
        image: meta.data.image,
        tokenURI
      }
      return item
    }))
    setNfts(items)
    setLoadingState('loaded') 
  }
  function listNFT(nft) {
    history.push(`/resell-nft?id=${nft.tokenId}&tokenURI=${nft.tokenURI}`)
  }
  if (loadingState === 'loaded' && !nfts.length) return (<h1 className="py-10 px-20 text-3xl">No assets owned</h1>)
  return (
    // <div className="flex justify-center">
    //   <div className="p-4">
    //     <div className=" pt-4">
    //       {
    //         nfts.map((nft, i) => (
    //           <div key={i} className="border  overflow-hidden">
    //             <img src={nft.image} className="rounded" />
    //             <div className="p-4 bg-black">
    //               <p className=" font-bold text-white">Price - {nft.price} Eth</p>
    //             </div>
    //           </div>
    //         ))
    //       }
    //     </div>
    //   </div>
    // </div>

    <div className='p-4'>


    {
        nfts.map((nft, i) => (


            <div className=' col-lg-3 col-sm-1 col-md-6 d-inline-block p-3 ' >

                <div className=''>

                    <div className=' bg-dark  border border-muted rounded-9 '>


                        <div className='card    rounded-9 bggtimer '>
                            <div className='card   border border-muted rounded-9 bggtimer'>

                                <img src={nft.image} className='rounded-9 p-3  ch'></img>

                                <div className='bg-dark col-sm-12 col-lg-6 col-md-8 mx-auto rounded-9 car-tim  hover-overlay  border border-muted'>
                                    <a ><h6 className='my-auto  text-light '> <i class="fas fa-clock p-2"></i> <Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                    <div class="mask  rounded-9 bgbtt-gra">
                                        <a ><h6 className='my-auto  text-light'><i class="fas fa-clock p-2"></i><Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                    </div>
                                </div>


                                <h5 className=' fw-bolder mx-3 text-light'>{nft.name}</h5>
                                <p className=' fw-bolder mx-3 text-light'>{nft.description}</p>



                                {/* if you want to show current owner show that */}


                                <p className=' fw-bolder mx-3 text-light'>owner: <span className='tx-sm'>{nft.owner}</span></p>
                                <p className=' fw-bolder mx-3 text-light'>seller: <span className='tx-sm'>{nft.seller}</span></p>

                            </div>
                            <span class="badge rounded-pill badge-notification bg-dark mt-3  p-3 align-self-end  hover-overlay border border-muted" > <i class="fas fa-heart"></i>  60 </span>

                        </div>
                        <div className='container'>
                            <div className='row mt-3 fw-bold text-light'>
                                <div className='col-6'>
                                    <h6>RESERVE PRICE</h6>
                                    <h5>{nft.price}</h5>

                                </div>
                                <div className='col-6'>
                                    <h6>SHARE</h6>
                                    <h6><i class="fab fa-facebook-square "><i class="fab fa-twitter mx-3"></i></i><i class="fab fa-instagram"></i></h6>

                                </div>

                            </div>

                            {/* <div className='mx-auto p-1'>
                                <button className="btn btn-danger col-12 " onClick={() => buyNft(nft)}>Buy</button>
                            </div> */}

                        </div>










                    </div>

                </div>
            </div>))
    }
</div>
  )
}